/**
 * Customizes the main "Add to cart" button label (adds the price) and the
 * trust microcopy beneath it, and relabels Horizon's native sticky
 * add-to-cart bar to a single compact line. Purely text/DOM additions —
 * the actual add-to-cart behavior is untouched (still Horizon's own).
 */
(function () {
  'use strict';

  function formatPrice(text) {
    return (text || '').trim();
  }

  function getPriceText() {
    var priceEl = document.querySelector('product-price .price');
    return priceEl ? formatPrice(priceEl.textContent) : '';
  }

  function enhanceMainButton() {
    var buttons = document.querySelectorAll('.add-to-cart-button');
    buttons.forEach(function (btn) {
      if (btn.closest('sticky-add-to-cart')) return; // handled separately

      // Newer markup (sticky bar): nested span to target directly.
      var label = btn.querySelector('.add-to-cart-text__content > span:first-child');
      var price = getPriceText();
      if (!price) return;
      var newText = 'AJOUTER AU PANIER — ' + price;

      if (label) {
        if (label.textContent !== newText) label.textContent = newText;
        return;
      }

      // Standalone form button: "Ajouter au panier" is a bare text node
      // sitting directly inside the button, between the icon and the
      // "added" confirmation span.
      btn.childNodes.forEach(function (node) {
        if (node.nodeType === Node.TEXT_NODE) {
          var trimmed = node.textContent.trim();
          if (trimmed.length > 0 && trimmed !== newText) {
            node.textContent = node.textContent.replace(trimmed, newText);
          }
        }
      });
    });
  }

  function enhanceTrustLine() {
    var buttons = document.querySelectorAll('.add-to-cart-button');
    buttons.forEach(function (btn) {
      if (btn.closest('sticky-add-to-cart')) return;
      var row = btn.closest('.product-form-buttons') || btn.parentElement;
      if (!row) return;
      var parent = row.parentElement;
      if (!parent || parent.querySelector('.mp-trust-line')) return;
      var trust = document.createElement('p');
      trust.className = 'mp-trust-line';
      trust.textContent = 'Paiement sécurisé · Livraison suivie';
      row.insertAdjacentElement('afterend', trust);
    });
  }

  function enhanceStickyBar() {
    var sticky = document.querySelector('sticky-add-to-cart');
    if (!sticky) return;

    var info = sticky.querySelector('.sticky-add-to-cart__info');
    var variantLine = sticky.querySelector('.sticky-add-to-cart__variant');
    if (variantLine && variantLine.style.display !== 'none') {
      variantLine.style.display = 'none';
    }

    var priceWrap = sticky.querySelector('.sticky-add-to-cart__price');
    var priceText = priceWrap ? formatPrice(priceWrap.textContent) : getPriceText();

    if (info && priceText && !info.querySelector('.mp-sticky-price')) {
      var priceSpan = document.createElement('span');
      priceSpan.className = 'mp-sticky-price';
      priceSpan.textContent = ' · ' + priceText;
      var title = info.querySelector('.sticky-add-to-cart__title');
      if (title) title.appendChild(priceSpan);
    }

    var btnLabel = sticky.querySelector('.add-to-cart-text__content > span:first-child');
    if (btnLabel && btnLabel.textContent !== 'AJOUTER') {
      btnLabel.textContent = 'AJOUTER';
    }
  }

  function applyAll() {
    enhanceMainButton();
    enhanceTrustLine();
    enhanceStickyBar();
  }

  function init() {
    applyAll();
    var mutating = false;
    var observer = new MutationObserver(function () {
      if (mutating) return;
      mutating = true;
      try {
        applyAll();
      } finally {
        Promise.resolve().then(function () {
          mutating = false;
        });
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
